"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initBanners = void 0;
var newsletter_1 = require("./newsletter");
function initBanners(pageName) {
    (0, newsletter_1.newsletterInit)(pageName);
}
exports.initBanners = initBanners;
